import i18n from "lib/i18n";
import { template } from "lodash";
import { View } from "backbone";
import ButtonView from "views/button_view";
/* eslint-disable
    constructor-super,
    func-names,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-return-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentRecommendsView;

// TODO: refactor, too many conditionals
export default CommentRecommendsView = (function () {
  CommentRecommendsView = class CommentRecommendsView extends View {
    static initClass() {
      this.prototype.tagName = "div";
      this.prototype.className = "comment-recommends-view";

      this.prototype.highlyRecommendedTemplate = template(`\
<i class="icon-favourite"></i>
<div class="hover tooltip bottom">
  <p><%= i18n.t('comment.label.highly_recommended') %></p>
</div>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);
      this._handleRecommend = this._handleRecommend.bind(this);
      this.recommended = options != null ? options.recommended : undefined;
      this.highlyRecommended = options != null ? options.highlyRecommended : undefined;

      if (this.highlyRecommended) { this.$el.addClass("highly-recommended"); }

      this.recommendButtonView = new ButtonView({ label: this._buttonText(), className: this._buttonClass() });
      this.recommendButtonView.on("click", this._handleRecommend);

      return this.render();
    }

    render() {
      if (this.highlyRecommended) {
        this.el.innerHTML = this.highlyRecommendedTemplate();
      } else {
        this.el.innerHTML = "";
      }

      return this.recommendButtonView.$el.appendTo(this.$el);
    }

    _updateButton() {
      this.recommendButtonView.setTitle(this._buttonText());
      return this.recommendButtonView.el.className = this._buttonClass();
    }

    _buttonClass() {
      if (this.recommended) {
        return "button small primary";
      }
      return "button small";
    }

    _buttonText() {
      if (this.recommended) {
        return i18n.t("comment.button.recommended");
      }
      return i18n.t("comment.button.recommend");
    }

    _handleRecommend(event) {
      this.recommended = !this.recommended;
      this._updateButton();

      if (this.recommended) {
        return this.trigger("comment:recommend");
      }
      return this.trigger("comment:unrecommend");
    }
  };
  CommentRecommendsView.initClass();
  return CommentRecommendsView;
}());
